module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAMAAACnUt2HAAAAY1BMVEUAAAAAAAAqKipGRkZERERBQUFCQkJERERGRkZDQ0NGRkZFRUVDQ0NERERDQ0NERERDQ0NERERFRUVERERERERDQ0NDQ0NERERERERERERERERERERDQ0NERERERERERERERETwH6pHAAAAIHRSTlMAAQYWHisyOEJMTVVfZWZteY+Rk57M2Nrd5ujw8vj5/V0RlyYAAACGSURBVBjTdZBHFsJADEM16Q1SJn1iovufMosQGMD8lZ+emwQAgMn7cdvGPjd4kQ58MqSXVgk5tXXdTqRUp1bsXMuzLFfuBQCEjnN0DUUzXQjAUuL3+lhogcCxg0dHFyAjE19MyAx3ivFFI7yh4YIPFjZ6p7pTvf7954P2nyPVu56SnudP8geUCA7al2qPYAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/ico_store.png
// module id = Z3QE
// module chunks = 0